// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {colors} from '../../assets/styles/colors';
import {TextField} from '@material-ui/core';
import {MuiThemeProvider, createTheme} from '@material-ui/core/styles';

import type {TextFieldProps} from '@material-ui/core';

type Props = {
  className?: string,
  children?: React.Node,
  label?: React.Node,
  color?: string,
} & TextFieldProps;

const useStyles = props =>
  makeStyles(theme => ({
    root: {
      overflow: 'hidden',
      borderRadius: '8px',
      border: `1.25px solid ${colors.grey300}`,
      boxSizing: 'border-box',
      backgroundColor: 'white !important',
      color: `${colors.grey800} !important`,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
    input: {padding: '10px 8px'},
    focused: {},
    textField: {},
    textInputLabel: {
      color: colors.grey600,
    },
    textInput: {
      borderRadius: '8px',
      border: `1.25px solid ${colors.grey300}`,
      boxSizing: 'border-box',
      backgroundColor: 'white !important',
      color: colors.grey800,
      flexWrap: 'nowrap',

      '&.MuiFilledInput-multiline': {
        padding: 'unset',
        flexWrap: 'wrap',
      },
      '& .MuiFilledInput-input': {
        padding: '15px',
      },
      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: colors.grey200,
      },
      '&.Mui-focused': {
        border: `1px solid ${colors.grey500} `,
        backgroundColor: 'white ',
        color: `${colors.grey800} `,
      },
      '&.Mui-error': {
        border: `1px solid #f44336`,
      },
    },
  }));

const theme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        '&$focused': {
          border: `1px solid ${colors.grey500} `,
          backgroundColor: 'white ',
          color: `${colors.grey800} `,
        },
        '&$error': {
          border: '1.25px solid #f44336 !important',
        },
        '&$disabled': {
          backgroundColor: `${colors.grey200} !important`,
        },
      },
    },
    MuiFormLabel: {
      root: {
        color: `${colors.grey600} !important`,
        '&$error': {
          color: '#f44336 !important',
        },
      },
    },
  },
  typography: {
    fontFamily: '"Poppins", "Muli", sans-serif',
  },
});

export default function CustomTextField(props: Props) {
  const {label, className, InputProps, ...otherProps} = props;

  const hasStarIcon = Boolean(InputProps && InputProps.startAdornment);
  const classes = useStyles(hasStarIcon)();

  if (label) {
    return (
      <MuiThemeProvider theme={theme}>
        <TextField
          variant="filled"
          fullWidth
          className={`${className ? className : ''}`}
          InputProps={{
            ...InputProps,
            className: classes.root,
            disableUnderline: true,
          }}
          label={label}
          {...otherProps}
        />
      </MuiThemeProvider>
    );
  } else {
    return (
      <TextField
        variant="filled"
        fullWidth
        className={`${classes.textField} ${className ? className : ''}`}
        InputProps={{
          ...InputProps,
          className: classes.textInput,
          disableUnderline: true,
        }}
        InputLabelProps={{
          className: classes.textInputLabel,
          ...otherProps.InputLabelProps,
        }}
        {...(otherProps: any)}
      />
    );
  }
}

CustomTextField.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  InputProps: PropTypes.object,
};
